import React, { useRef, useEffect, useState } from 'react'
import Paper from '@mui/material/Paper'
import './image.css'
import { Stack, StepContext } from '@mui/material'
import _ from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import moment from 'moment'
import { styled } from '@mui/material/styles'
import IconButton from '@mui/material/IconButton'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'
import { store } from '../../../store/store'
import { get_corrected_image_details, create_virtual_shelves } from '../../scripts/scripts'
import { Popover, PopoverPaused } from "./popover"
import { planogramImageActions } from '../../../store/store'

export const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: 'rgba(32, 38, 43, 0.95)'
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: 'rgba(32, 38, 43, 0.95)',
    maxWidth: '15rem'
  }
}))

const get_image_url = image => {
  return (
    `https://caiproduction002.blob.core.windows.net/ira/audit_images/` +
    image +
    `?sv=2020-08-04&ss=bfqt&srt=sco&sp=rwdlacupitfx&se=2050-05-06T01:59:09Z&st=2022-05-05T17:59:09Z&spr=https&sig=SsFQp5OkIrSG9gVnf4V9F4Vi463mtW25t0Vw2SQzVIM%3D`
  )
}

const get_thumbnail_url = thumbnail => {
  return (
    'https://caiproduction002.blob.core.windows.net/ira/iat/thumbnails/' +
    thumbnail +
    '?sv=2020-08-04&ss=bfqt&srt=sco&sp=rwdlacupitfx&se=2050-05-06T01:59:09Z&st=2022-05-05T17:59:09Z&spr=https&sig=SsFQp5OkIrSG9gVnf4V9F4Vi463mtW25t0Vw2SQzVIM%3D'
  )
}

export default function VirtualTwin (props) {
  const canvasRef = useRef(null)
  const dispatch = useDispatch()
  const imgNo = props.imgNo
  const [open, setOpen] = useState(false)
  const [cursorDim, setCursorDim] = useState([0, 0])
  const [popoverData, setPopoverData] = useState([])
  const [popoverPaused, setPopoverPaused] = useState(false)
  const [popoverPausedCoords, setPopoverPausedCoords] = useState([])
  const [pausedPopoverData, setPausedPopoverData] = useState([])
  const [cropCoords, setCropCoords] = useState([0, 0, 0, 0])
  const [pausedCropCoords, setPausedCropCoords] = useState([0, 0, 0, 0])
  const [popoverLiveDim, setPopoverLiveDim] = useState([0, 0])
  const { virtualImage } = useSelector(state => state.planogramImageStore)
  const activeVirtualAnalysisTab = virtualImage.activeAnalysisTab
  const pngAnalysis = virtualImage.analysis.png

  const brandAnalysis = virtualImage.analysis.brands
  const brandColors = brandAnalysis.colors

  const handlePopoverPause = () => {
    if (open || popoverPaused) {
      setPopoverPaused(!popoverPaused)
      setPopoverPausedCoords(cursorDim)
      setPausedPopoverData(popoverData)
      setPausedCropCoords(cropCoords)
    }
  }

  const colorResolver = box_details => {
    if (activeVirtualAnalysisTab === "png") {
      if (box_details.isShelf === 1) {
        return pngAnalysis.options.shelf.color
      } else if (box_details.ai_data.type === "customer") {
        return 'rgba(50, 50, 50, 0.875)'
      } else if (box_details.ai_data.type === "competition") {
        return 'rgba(50, 50, 50, 0.875)'
      } else {
        return pngAnalysis.options.default.color
      }
    }
  }

  const fillResolver = box_details => {
    if (activeVirtualAnalysisTab === "png") {
      if (box_details.isShelf === 1) {
        return pngAnalysis.options.shelf.color
      } else if (box_details.ai_data.type === "customer") {
        return pngAnalysis.options.customer.color
      } else if (box_details.ai_data.type === "competition") {
        return pngAnalysis.options.competition.color
      } else {
        return 'rgba(255, 255, 255, 0)'
      }
    } else if (activeVirtualAnalysisTab === "brands") {
      if (brandAnalysis.currentSelectedType === "brands") {
        const brand = box_details.ai_data.sku_name
        if (brand in brandColors) {
          return brandColors[brand]
        } else if (box_details.isShelf === 1) {
          return pngAnalysis.options.shelf.color
        } else {
          return 'rgba(255, 255, 255, 0)'
        }
      } else if (brandAnalysis.currentSelectedType === "skus") {
        const skus = box_details.ai_data.skus
        if (skus in brandColors) {
          return brandColors[skus]
        } else if (box_details.isShelf === 1) {
          return pngAnalysis.options.shelf.color
        } else {
          return 'rgba(255, 255, 255, 0)'
        }
      }
    }
  }

  const handlePopoverLiveDim = e => {
    setPopoverLiveDim(e)
  }

  const filterCheck = (boxesDetails, linear, drilldown) => {
    // applying default filters...
    let boxes = boxesDetails.filter(
      row => row.secCategory && row.secCategory[0] !== 'DISPLAY'
    )

    // returnig boxes as it is if no option is selected
    return boxes
  }

  useEffect(() => {
    // applying filters as needed
    let boxes = filterCheck(props.imageDetails.thumbnailsDetails)
    const data = get_corrected_image_details(boxes)
    boxes = data["boxes"];
    const virtualShelves = data["virtual_shelves"];
    const slotsOccupied = data["slotsOccupied"];
    // dispatch(planogramImageActions.setOosData(slotsOccupied));

    const canvas = canvasRef.current
    const ctx = canvas.getContext('2d')
    const img = new Image()
    img.crossOrigin = 'anonymous'
    img.src = get_image_url(props.imageDetails.imageName)
    img.onload = () => {
      canvas.width = img.width
      canvas.height = img.height

      // drawing image
      ctx.drawImage(img, 0, 0)

      // filling image white
      ctx.fillStyle = 'white'
      ctx.fillRect(0, 0, canvas.width, canvas.height)

      // giving image border
      ctx.lineWidth = 2.5
      ctx.strokeStyle = 'rgb(50, 50, 50)'
      ctx.setLineDash([10, 10])
      ctx.strokeRect(0, 0, canvas.width, canvas.height)
      ctx.lineWidth = 1.5

      let i = 0
      while (i < boxes.length) {
        // drawing default AI boxes
        let w = boxes[i].xmax - boxes[i].xmin
        let h = boxes[i].ymax - boxes[i].ymin
        const color = colorResolver(boxes[i])
        const fill = fillResolver(boxes[i])

        ctx.setLineDash([10, 10])
        ctx.strokeStyle = color
        ctx.strokeRect(boxes[i].xmin, boxes[i].ymin, w, h)

        ctx.fillStyle = fill
        ctx.fillRect(boxes[i].xmin, boxes[i].ymin, w, h)

        if (boxes[i].isShelf === 1) {
          ctx.font = "40px Ariel";
          ctx.fillStyle = "rgb(255, 255, 255)";
          ctx.textAlign = 'center'; // Center the text horizontally

          // Draw the text in the middle of the rectangle
          ctx.fillText(boxes[i].shelfId, boxes[i].xmin + (boxes[i].xmax - boxes[i].xmin)/2, boxes[i].ymin + (boxes[i].ymax - boxes[i].ymin)/2);
        }
        if (boxes[i].isShelf === 0) {
          ctx.font = "40px Ariel";
          ctx.fillStyle = "rgb(0, 0, 0)";
          ctx.textAlign = 'center'; // Center the text horizontally

          // Draw the text in the middle of the rectangle
          ctx.fillText(boxes[i].hid.skuIdx, boxes[i].xmin + (boxes[i].xmax - boxes[i].xmin)/2, boxes[i].ymin + (boxes[i].ymax - boxes[i].ymin)/2);
        }
        if (boxes[i].isOOS) {
          ctx.strokeStyle = "rgb(0, 0, 0)"
          ctx.setLineDash([10, 10])
          ctx.strokeRect(boxes[i].xmin, boxes[i].ymin, w, h)

          ctx.fillStyle = "rgb(255, 236, 0)"
          ctx.fillRect(boxes[i].xmin, boxes[i].ymin, w, h)
        }
        i++
      }

      let j = 0;
      while (j < virtualShelves.length) {
        ctx.setLineDash([10, 10]);
        ctx.strokeStyle = "rgba(255, 0, 179, 0.875)";
        const h = virtualShelves[j].ymax - virtualShelves[j].ymin;
        const w = virtualShelves[j].xmax - virtualShelves[j].xmin;
        ctx.lineWidth = 5
        ctx.strokeRect(virtualShelves[j].xmin, virtualShelves[j].ymin, w, h);
        j++;
      }

      let k = 0;
      while (k < slotsOccupied.length) {
        if (slotsOccupied[k]["isOccupied"] === 0) {
          const x = slotsOccupied[k]["xmin"] + (slotsOccupied[k]["xmax"] - slotsOccupied[k]["xmin"])/2;
          const y = slotsOccupied[k]["ymin"] + (slotsOccupied[k]["ymax"] - slotsOccupied[k]["ymin"])/2;
          ctx.beginPath();
          ctx.arc(x, y, 30, 0, 2 * Math.PI);
          ctx.fillStyle = "yellow"; // Fill the circle with a red color
          ctx.fill();
          ctx.closePath();
        }
        k++;
      }

      if (!popoverPaused) {
        canvas.addEventListener('mousemove', event => {
          const x = event.offsetX / props.resize
          const y = event.offsetY / props.resize

          const screenX = event.clientX
          const screenY = event.clientY

          const match = boxes.filter(
            box => x > box.xmin && x < box.xmax && y > box.ymin && y < box.ymax
          )

          if (match.length === 1) {
            setCursorDim([screenX, screenY])
            setOpen(match.length > 0)
            setPopoverData(match[0])
            if (match.length > 0) {
              setCropCoords([
                match[0]['xmin'],
                match[0]['ymin'],
                match[0]['xmax'],
                match[0]['ymax']
              ])
            }
          } else {
            // selecting the box with the minimum area if matches for a coordinate is > 1
            const areas = match.map(row => {
              return (row.ymax - row.ymin) * (row.xmax - row.xmin)
            })

            const min_area = _.min(areas)
            const min_area_idx = areas.indexOf(min_area)
            setCursorDim([screenX, screenY])
            setOpen(match.length > 0)
            setPopoverData(match[min_area_idx])
            if (match.length > 0) {
              setCropCoords([
                match[min_area_idx]['xmin'],
                match[min_area_idx]['ymin'],
                match[min_area_idx]['xmax'],
                match[min_area_idx]['ymax']
              ])
            }
          }
        })
      }

      // closing the popup incase cursor leaves the canvas
      canvas.addEventListener('mouseleave', event => {
        if (!popoverPaused) {
          setOpen(false)
        }
      })
    }
  }, [props, virtualImage])

  // choosing popover view based on popover paused state
  let popoverView
  if (popoverPaused) {
    popoverView = (
      popoverPaused &&
      <PopoverPaused
        display={popoverPaused}
        dim={popoverPausedCoords}
        data={pausedPopoverData}
        cropCoords={pausedCropCoords}
        imageName={props.imageDetails.imageName}
        popoverLiveDim={popoverLiveDim}
      />
    )
  } else {
    popoverView = (
      (open) &&
      <Popover
        display={open}
        dim={cursorDim}
        data={popoverData}
        cropCoords={cropCoords}
        imageName={props.imageDetails.imageName}
        popoverLiveDim={handlePopoverLiveDim}
      />
    )
  }

  return (
    <div className='image-analysis'>
      <canvas
        id={props.imgNo}
        onClick={handlePopoverPause}
        ref={canvasRef}
        style={{
          width: `${props.dim[0] * props.resize}px`,
          height: `${props.dim[1] * props.resize}px`
        }}
      ></canvas>
      {popoverView}
    </div>
  )
}
